import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const FormInputDropdown = ({
  name,
  control,
  sx,
  options,
  rules,
  disabled,
  staticValue = '',
  onChange: onchange,
  placeholder,
  disabledItem,
}) => {
  const { t } = useTranslation();

  const generateSingleOptions = value => {
    return options?.map(option => {
      return (
        <MenuItem key={option.value} selected={option.value === value} value={option.value}>
          {t(option.label)}
        </MenuItem>
      );
    });
  };

  return (
    <FormControl size={'small'} sx={sx}>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Select
            displayEmpty
            error={!!error}
            placeholder={placeholder}
            onChange={e => {
              onChange(e.target.value);
              if (onchange) onchange(e);
            }}
            value={value ?? staticValue ?? ''}
            disabled={disabled}
            sx={{
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#4AB3BC',
              },
              ...sx,
            }}>
            {disabledItem}
            {generateSingleOptions(value)}
          </Select>
        )}
      />
    </FormControl>
  );
};
